import React, { memo, forwardRef } from "react";
const SvgCapitalEta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M19.992 14.296V8.344c0-.496.128-.84.384-1.032.256-.208.528-.312.816-.312.272 0 .536.104.792.312.256.192.384.536.384 1.032v14.688c0 .496-.128.848-.384 1.056-.256.192-.52.288-.792.288-.288 0-.56-.096-.816-.288-.256-.208-.384-.56-.384-1.056v-6.624h-8.616v6.624c0 .496-.128.848-.384 1.056-.256.192-.52.288-.792.288-.288 0-.56-.096-.816-.288-.256-.208-.384-.56-.384-1.056V8.344c0-.496.128-.84.384-1.032C9.64 7.104 9.912 7 10.2 7c.272 0 .536.104.792.312.256.192.384.536.384 1.032v5.952h8.616z"
      />
    </svg>
  );
});
SvgCapitalEta.displayName = "SvgCapitalEta";
const MemoForwardRef = memo(SvgCapitalEta);
export default MemoForwardRef;
